<template>
  <div class="project-detail" v-loading="loading">
    <div class="body-content" v-if="!loading">
      <h2>“{{ info.name }}”项目（{{ info.number }}）简介</h2>
      <div>
        <label class="title">项目概况</label>
        <div class="message">
          <table>
            <tr>
              <th width="180">项目名称</th>
              <td width="420">{{ info.name }}</td>
              <th width="180">项目标号</th>
              <td width="420">{{ info.number }}</td>
            </tr>
            <tr>
              <th>所属专项</th>
              <td>国家质量基础的共性技术研究与应用</td>
              <th>研究经费</th>
              <td>
                总预算 {{ info.funds }} 万元,其中中央财政专项经费{{
                  info.specialFunds
                }}万元
              </td>
            </tr>
            <tr>
              <th>单位数</th>
              <td>{{ info.unitNumber }}</td>
              <th>总人数</th>
              <td>{{ info.peopleNumber }}</td>
            </tr>
            <tr>
              <th>牵头单位</th>
              <td><router-link :to="'/websiteSearch?name='+info.leadUnit" target="_blank"><img src="../../assets/images/blue.png">{{ info.leadUnit }}</router-link></td>
              <th>项目推荐单位</th>
              <td><router-link :to="'/websiteSearch?name='+info.recommendUnit" target="_blank"><img src="../../assets/images/blue.png">{{ info.recommendUnit }}</router-link></td>
            </tr>
            <tr>
              <th>项目负责人</th>
              <td>{{ info.leader }}</td>
              <th>项目联系人</th>
              <td></td>
            </tr>
          </table>
        </div>
        <label class="title">参与单位</label>
        <div class="swiper-container" id="swiper1" v-if="info.projectUnitList" style="margin-bottom: 30px;">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="unit in info.projectUnitList" :key="unit.id">
              <router-link :to="'/websiteSearch?name='+unit.name" target="_blank">
                <img v-if="unit.coverImage" :src="fileUrl + unit.coverImage" :alt="unit.name">
                <img v-else src="../../assets/images/unit-default.png" width="300" :alt="unit.name">
                <span>{{unit.name}}</span>
              </router-link>
            </div>
          </div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
        <div>
          <div style="width: 67%; float: left;margin-bottom: 30px;" class="left">
            <label class="title">项目背景与意义</label>
            <div class="content">
              <div v-html="info.background"></div>
            </div>
            <label class="title">研究目标与内容</label>
            <div class="content">
              <div v-html="info.goal" class="con1"></div>
              <div v-html="info.content" class="con2"></div>
              <div class="bttn0 hide">
                <span class="white" @click="infoCon0">查看全部</span>
              </div>
              <div class="bttn hide"></div>
              <div class="bttn1 hide">
                <span class="blue" @click="infoCon1">查看全部</span>
              </div>
            </div>
          </div>
          <div style="width: 30%; float: right" class="right">
            <div class="slidebar-item">
              <div class="item-header">
                <label class="title">项目指数</label>
              </div>
              <ul>
                <li class="text-item">
                  <div class="" id="radarChart" style="height: 300px"></div>
                  <div class="prev-icon" style="display: inline-block">
                    <div class="stars">
                      <ul>
                        <li v-for="(value, label) in radarData" :key="label">
                          <label>{{ label }}：</label>
                          <rate
                            :count="value"
                            :key="label"
                            :disabled="true"
                          ></rate>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="prev-icon" style="display: inline-block">
                    <ul>
                      <li
                        class="tag"
                        v-for="key in keyWords"
                        :key="key"
                        :style="
                          'border-color:rgb(' +
                          Math.random() * 255 +
                          ',' +
                          Math.random() * 255 +
                          ',' +
                          Math.random() * 255 +
                          ')'
                        "
                      >
                        {{ key }}
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="task-list">
          <div style="width: 100%; display: flex; flex-direction: column">
            <label class="title">项目课题/论文</label>
            <div
              class="card"
              v-for="(task, index) in info.taskVOList"
              :key="task.id"
              style="margin: 4px 0 0;"
            >
              <div class="card-title">
                <span>{{ Number(index) + 1 }}、{{ task.name }}</span>
                <span>负责单位：<router-link :to="'/websiteSearch?name='+task.leadUnit" target="_blank"><img src="../../assets/images/blue.png">{{ task.leadUnit }}</router-link></span>
              </div>
              <div class="card-content" v-if="task.paperList.length>0">
                <template v-if="activePaper != index">
                <div class="case" v-for="(paper,item) in task.paperList" :key="paper.id"
                  v-if="item<4"
                >
                    <img
                      src="../../assets/images/pro/lw (1).png"
                      alt=""
                      width="100%"
                    />
                    <div class="case-content">
                      <div class="case-title f14 case-lim2">
                        {{ paper.paperName }}
                      </div>
                      <div class="case-lim">
                        <span class="f14">作者名：</span>{{ paper.authorName }}
                      </div>
                      <div>
                        <span class="f14">数据库：</span>{{ paper.paperType }}
                      </div>
                      <div
                        class="case-btn"
                        @click="toDetail(task.id, paper.id)"
                      >
                        查看详情
                      </div>
                    </div>
                    <el-dialog
                      :title="title"
                      :visible.sync="dialogVisible"
                      width="70%"
                    >
                      <div class="dialog-con">
                        <table>
                          <tr>
                            <th>课题：</th>
                            <td>{{ numberList }}</td>
                            <th>题目：</th>
                            <td>{{ infoList.paperName }}</td>
                          </tr>
                          <tr>
                            <th>作者名：</th>
                            <td>{{ infoList.authorName }}</td>
                            <th>来源：</th>
                            <td>{{ infoList.source }}</td>
                          </tr>
                          <tr>
                            <th>发表时间：</th>
                            <td>{{ infoList.pubTime }}</td>
                            <th>数据库：</th>
                            <td>{{ infoList.paperType }}</td>
                          </tr>
                          <tr>
                            <th>摘要：</th>
                            <td colspan="3">{{ infoList.abstractContent }}</td>
                          </tr>
                          <tr>
                            <th>关键词：</th>
                            <td colspan="3">{{ infoList.keyWord }}</td>
                          </tr>
                          <tr>
                            <th>基金资助：</th>
                            <td colspan="3">{{ infoList.fundHelp }}</td>
                          </tr>
                          <tr>
                            <th>DOI：</th>
                            <td>{{ infoList.doi }}</td>
                          </tr>
                          <tr>
                            <th>专辑：</th>
                            <td>{{ infoList.specialIssue }}</td>
                            <th>专题：</th>
                            <td>{{ infoList.specialSubject }}</td>
                          </tr>
                          <tr>
                            <th>分类号：</th>
                            <td>{{ infoList.typeNumber }}</td>
                            <th>论文链接：</th>
                            <td><a :href="infoList.cnkiLink">查看</a></td>
                          </tr>
                        </table>
                      </div>
                    </el-dialog>
                </div>
                </template>
                <template v-if="activePaper == index">
                <div class="case" v-for="(paper) in task.paperList" :key="paper.id">
                    <img
                      src="../../assets/images/pro/lw (1).png"
                      alt=""
                      width="100%"
                    />
                    <div class="case-content">
                      <div class="case-title f14 case-lim2">
                        {{ paper.paperName }}
                      </div>
                      <div class="case-lim">
                        <span class="f14">作者名：</span>{{ paper.authorName }}
                      </div>
                      <div>
                        <span class="f14">数据库：</span>{{ paper.paperType }}
                      </div>
                      <div
                        class="case-btn"
                        @click="toDetail(task.id, paper.id)"
                      >
                        查看详情
                      </div>
                    </div>
                    <el-dialog
                      :title="title"
                      :visible.sync="dialogVisible"
                      width="70%"
                    >
                      <div class="dialog-con">
                        <table>
                          <tr>
                            <th>课题：</th>
                            <td>{{ numberList }}</td>
                            <th>题目：</th>
                            <td>{{ infoList.paperName }}</td>
                          </tr>
                          <tr>
                            <th>作者名：</th>
                            <td>{{ infoList.authorName }}</td>
                            <th>来源：</th>
                            <td>{{ infoList.source }}</td>
                          </tr>
                          <tr>
                            <th>发表时间：</th>
                            <td>{{ infoList.pubTime }}</td>
                            <th>数据库：</th>
                            <td>{{ infoList.paperType }}</td>
                          </tr>
                          <tr>
                            <th>摘要：</th>
                            <td colspan="3">{{ infoList.abstractContent }}</td>
                          </tr>
                          <tr>
                            <th>关键词：</th>
                            <td colspan="3">{{ infoList.keyWord }}</td>
                          </tr>
                          <tr>
                            <th>基金资助：</th>
                            <td colspan="3">{{ infoList.fundHelp }}</td>
                          </tr>
                          <tr>
                            <th>DOI：</th>
                            <td>{{ infoList.doi }}</td>
                          </tr>
                          <tr>
                            <th>专辑：</th>
                            <td>{{ infoList.specialIssue }}</td>
                            <th>专题：</th>
                            <td>{{ infoList.specialSubject }}</td>
                          </tr>
                          <tr>
                            <th>分类号：</th>
                            <td>{{ infoList.typeNumber }}</td>
                            <th>论文链接：</th>
                            <td><a :href="infoList.cnkiLink">查看</a></td>
                          </tr>
                        </table>
                      </div>
                    </el-dialog>
                </div>
                </template>
                <div style="text-align:center;width: 100%;"><a v-if="task.paperList.length>4" @click="showMore(index)" class="loadMore">点开查看全部<i class="el-icon-arrow-down" style="margin-left: 5px;"></i></a></div>
              </div>
            </div>
          </div>
          <div style="margin-top: 30px;">
            <label class="title">项目成果</label>
            <div class="proResu" style="padding: 20px">
              <table>
                <tr>
                  <th width="200">成果名称</th>
                  <th width="150">成果数量</th>
                  <th width="150">成果形式</th>
                  <th width="150">成果类型</th>
                </tr>
                <template>
                  <tr v-for="fruit in fruitList.records" :key="fruit.id">
                    <td width="300" @click="goFruit(fruit.id)"><a style="cursor: pointer;">{{ fruit.fruitName }}</a></td>
                    <td>{{ fruit.fruitCount }}</td>
                    <td>{{ fruit.fruitStyle }}</td>
                    <td>{{ fruit.fruitType }}</td>
                  </tr>
                </template>
              </table>
              <div class="pagination-box" v-if="fruitList.records.length != '0'">
                <el-pagination
                background
                layout="prev, pager, next, total"
                :total="page.total"
                @current-change="pageChange"
                >
            </el-pagination>
              </div>
            </div>
          </div>
          <div style="margin-top: 30px;">
            <label class="title">项目专利</label>
            <template>
            <div
              class="card"
              v-for="(patent) in info.patentList"
              :key="patent.id"
            >
              <div class="card-title">
                <span>专利名称：{{ patent.name }}（{{ patent.patentType }}）</span>
                <span>专利权人：{{ patent.patentPerson }}</span>
              </div>
              <div class="pic1">
                <div
                  class="img"
                  v-for="(patent2, index2) in patent.imageLists"
                  :key="index2"
                >
                  <img :src="fileUrl + patent2" alt="" height="280px" width="280px" />
                </div>
              </div>
            </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Rate from '../../components/rate/rate';
export default {
  name: 'projectDetail',
  components: { Rate },
  data () {
    return {
      fileUrl: '',
      id: '',
      info: {},
      infoList: {},
      numberList: '',
      imageList: [],
      fruitList: {},
      sub: {},
      loading: true,
      chart: null,
      keyWords: [],
      dialogVisible: false,
      title: '',
      formLabelWidth: '80px',
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      activePaper: -1
    };
  },
  created () {
    this.id = this.$route.query.id;
    this.fileUrl = FileUrl;
    this.pageChange(1);
    this.fetchDetail();
    this.fetchFruit();
  },
  watch: {
  },
  mounted () {
    setTimeout(() => {
      this.init();
      Swiper('#swiper1', {
        loop: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 4,
        paginationClickable: true,
        spaceBetween: 30,
        freeMode: true,
        centeredSlides: true,
        autoplay: 2500,
        autoplayDisableOnInteraction: false
      });
    }, 500);
  },
  methods: {
    showMore (i) {
      this.activePaper = i
    },
    init () {
      var heigh = $('.right').height() + 'px';
      if ($('.left').height() - 30 > $('.right').height()) {
        $('.left').css({
          height: heigh,
          position: 'relative',
          overflow: 'hidden'
        });
        $('.bttn0').removeClass('hide');
        $('.bttn1').removeClass('hide');
        $('.bttn').removeClass('hide');
      }
    },
    pageChange (current) {
    //   console.log(current);
      this.page.pageNo = current;
      this.fetchFruit();
    },
    toDetail (taskid, paperid) {
      this.dialogVisible = true;
      this.fetch(`/dataapi/open/nqi/project/infoDetail/${this.id}`)
        .then((res) => {
          let shuju = [];
          for (let task of res.result.taskVOList) {
            if (task.id === taskid) {
              this.numberList = task.number;
              shuju.push(task);
              for (let xiangq of shuju[0].paperList) {
                if (xiangq.id === paperid) {
                  this.infoList = xiangq;
                }
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    fetchFruit () {
      this.fetch(`/dataapi/open/nqi/fruit/list/`, {projectId: this.id, pageNo: this.page.pageNo}).then((res) => {
        this.page.total = res.result.total;
        this.fruitList = res.result;
      }).catch((err) => {
        console.log(err);
      });
    },
    fetchDetail () {
      this.fetch(`/dataapi/open/nqi/project/infoDetail/${this.id}`)
        .then((res) => {
          let sub = {};
          let imageList = [];
          for (let task of res.result.taskVOList) {
            sub[task.id + ''] = true;
          }
          this.sub = sub;
          this.info = res.result;
          //   console.log(this.info, 'a');
          //   console.log(res.result.patentList[0].image.split(','), '11');
          this.info.patentList.map((item, index) => {
            imageList.push(Object.assign({}, item, { imageLists: [] }));
          });
          this.info.patentList = imageList;
          for (let i = 0; i < this.info.patentList.length; i++) {
            if (res.result.patentList[i].image === '') {
            //   console.log('err');
              return;
            } else {
              this.info.patentList[i].imageLists = res.result.patentList[i].image.split(',');
            }
          }
          this.loading = false;
          this.keyWords = this.info.keyWords.split(',');
          this.radarData = JSON.parse(this.info.score);
          const _self = this;
          this.$nextTick(function () {
            let indicator = [];
            let value = [];
            for (let key of Object.keys(_self.radarData)) {
              indicator.push({ name: key, max: 5 });
              value.push(Number(_self.radarData[key]));
            }
            _self.chart = echarts.init(document.getElementById('radarChart'));
            _self.chart.setOption({
              radar: [
                {
                  indicator: indicator,
                  radius: 100,
                  name: {
                    textStyle: {
                      color: '#fff',
                      backgroundColor: '#666',
                      borderRadius: 3,
                      padding: [3, 5]
                    }
                  }
                }
              ],
              series: [
                {
                  type: 'radar',
                  tooltip: {
                    trigger: 'item'
                  },
                  areaStyle: {},
                  data: [
                    {
                      value: value,
                      name: '项目指数'
                    }
                  ]
                }
              ]
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toggleSub (id) {
      this.sub[id] = !this.sub[id];
    },
    goFruit (id) {
      this.$router.push({ path: '/fruitDetail', query: { id: id } });
    },
    infoCon0 () {
      var heigh = $('.right').height() + 'px';
      $('.left').css({
        height: heigh,
        position: 'relative',
        overflow: 'hidden'
      });
      $('.bttn0').removeClass('show');
      $('.bttn').removeClass('hide');
      $('.bttn1').removeClass('hide');
    },
    infoCon1 () {
      $('.left').css({ height: 'auto', position: 'relative' });
      $('.left').removeAttr('overflow');
      $('.bttn0').addClass('show');
      $('.bttn').addClass('hide');
      $('.bttn1').addClass('hide');
    }
  }
};
</script>

<style lang="less">
.pagination-box {
    padding-top: 20px;
    text-align: center;
    .el-pagination {
      button {
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
      }
    }
    .el-pager {
      .number {
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
        font-size: 14px;
        font-family: HelveticaNeue;
        color: rgba(0, 0, 0, 0.65);
        font-weight: 400;
        &.active {
          background-color: rgba(46, 92, 154, 1) !important;
        }
      }
    }
  }
</style>

<style lang="less" scoped>
.body-content {
  display: flex;
  width: @body-width;
  margin: 0 auto;
  flex-flow: column;
}
.project-detail {
  margin-bottom: 50px;
  min-height: 450px;
  h2 {
    font-size: 32px;
    text-align: center;
    font-weight: bold;
    margin: 50px;
    line-height: 50px;
    color: rgba(0, 0, 0, 0.85);
  }
  .title {
    height: 20px;
    font-size: 20px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    line-height: 20px;
    margin-bottom: 12px;
    border-left: 12px solid #4f9cee;
    padding-left: 20px;
  }
  .message {
    margin-bottom: 30px;
    table {
      width: 100%;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      border-left: 1px solid rgba(0, 0, 0, 0.1);
      th {
        color: #000000;
        background: #f7f9fc;
        font-size: 14px;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        border-right: 1px solid rgba(0, 0, 0, 0.1);
        padding: 20px 22px;
      }
      td {
        font-size: 14px;
        color: #000000;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        border-right: 1px solid rgba(0, 0, 0, 0.1);
        padding: 20px 22px;
        a {
          cursor: pointer;
          img {
            width: 14px;
            display: inline-block;
            margin-top: -4px;
            margin-right: 4px;
          }
        }
      }
    }
  }
  .swiper-slide {
    a {
      display: block;
      width: 100%;
      height: 200px;
      line-height: 180px;
      text-align: center;
    }
    img {
      width: 200px;
      max-height: 100%;
    }
    span {
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 1;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      color: #fff;
      background-color: rgba(46, 92, 154, 1);
    }
  }
  .content {
    margin-bottom: 30px;
    font-size: 14px;
    line-height: 28px;
  }
  .task-list {
    .card {
      width: 100%;
      background-color: #f7f9fc;
      margin: 20px 0;
      .card-title {
        padding: 25px 20px 25px 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #2e5c9a;
        span {
          display: inline-block;
          font-size: 16px;
          font-weight: 500;
          a {
            cursor: pointer;
            img {
              width: 14px;
              display: inline-block;
              margin-top: -4px;
              margin-right: 4px;
            }
          }
        }
        i {
          font-style: normal;
        }
      }
      .card-content {
        display: flex;
        flex-wrap: wrap;
        padding: 25px 50px;
        .case {
          position: relative;
          border: 1px dashed black;
          margin-right: 20px;
          margin-bottom: 32px;
          .case-content {
            position: absolute;
            top: 0px;
            left: 0px;
            padding: 16px 24px;
            width: 274px;
          }
          .case-title {
            padding-bottom: 10px;
            border-bottom: 1px solid #2e5c9a;
          }
          .case-lim {
            margin: 25px 0 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .case-lim2 {
            word-break: break-all;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .case-btn {
            width: 76px;
            line-height: 24px;
            background: #ffffff;
            border-radius: 4px;
            border: 1px solid #2e5c9a;
            text-align: center;
            margin-top: 34px;
            color: #2e5c9a;
            cursor: pointer;
          }
        }
      }
    }
    .proResu {
      table {
        width: 100%;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        border-left: 1px solid rgba(0, 0, 0, 0.1);
        th {
          color: #000000;
          background: #f7f9fc;
          font-size: 14px;
          border-top: 1px solid rgba(0, 0, 0, 0.1);
          border-right: 1px solid rgba(0, 0, 0, 0.1);
          padding: 20px 22px;
        }
        td {
          font-size: 14px;
          color: #000000;
          border-top: 1px solid rgba(0, 0, 0, 0.1);
          border-right: 1px solid rgba(0, 0, 0, 0.1);
          padding: 20px 22px;
          i {
            margin-left: 12px;
          }
          .link {
            cursor: pointer;
            color: #2e5c9a;
          }
        }
      }
    }
  }
  .stars li {
    width: 50%;
    float: left;
    margin-bottom: 4px;
    > label {
      margin: 0;
    }
    .ff-rate {
      margin-left: 20px;
    }
  }
  .tag {
    float: left;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 4px 12px;
    cursor: default;
    margin: 12px 12px 0 0;
  }
  .bttn {
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 60px;
    padding-top: 15px;
    text-align: center;
    background-image: linear-gradient(
      -180deg,
      rgba(255, 255, 255, 0.5) 0%,
      #fff 100%
    );
  }
  .bttn0 {
    text-align: center;
    width: 100%;
  }
  .bttn1 {
    position: absolute;
    bottom: 0px;
    text-align: center;
    width: 100%;
  }
  .blue {
    width: 100px;
    height: 32px;
    line-height: 32px;
    background-color: #2e5c9a;
    color: #ffffff;
    display: inline-block;
    text-align: center;
    cursor: pointer;
  }
  .white {
    width: 100px;
    height: 32px;
    line-height: 32px;
    background-color: #ffffff;
    color: #2e5c9a;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    border: 1px solid #2e5c9a;
  }
  .pic1 {
    width: 100%;
    display: flex;
    flex-flow: wrap;
    // justify-content: space-between;
    padding: 20px 0;
    .img {
      margin: 10px 15px;
      width: 290px;
    }
  }
  .f14 {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }
  .loadMore{
      text-decoration: none;
      cursor: pointer;
  }
  .dialog-con {
    padding: 0 10px 24px;
    table {
      width: 100%;
      th {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        padding: 0px 15px 20px 0;
        text-align: right;
        min-width: 140px;
      }
      td {
        font-size: 14px;
        color: #000000;
        padding: 0px 15px 20px 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/project/detail.vue